<script>
export default {
  name: "MainMixin",
  data() {
    return {
      display: false,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  methods: {
    glowingLinksMobile() {
      if (this.isMobile) {
        let random = this.getRndInteger(1500, 3500);
        setTimeout(() => {
          console.log("yooo");
          return true;
        }, random);
      }
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    checkingOrientationQuery() {
      var mql = window.matchMedia("(orientation: landscape)");
      mql.addListener(this.handleOrientationChange);
      this.handleOrientationChange(mql);
    },
    handleOrientationChange(mql) {
      if (mql.matches) {
        this.resetZoomMobile();
        document.querySelector("html").classList.add("mobile-html");
        document.querySelector("body").classList.add("mobile-body");
        this.$store.commit("setOriented");
      }
    },
    init() {
      window.scrollTo(0, 0);
      this.$store.commit("setToPlace", "...");
      if (this.isMobile) {
        this.resetZoomMobile();
        document.querySelector("html").classList.add("mobile-html");
        document.querySelector("body").classList.add("mobile-body");
        this.checkingOrientationQuery();
      } else {
        document.querySelector("html").classList.add("noScroll");
      }
    },
    resetZoomMobile() {
      var scale = "scale(1)";
      document.body.style.webkitTransform = scale; // Chrome, Opera, Safari
      document.body.style.msTransform = scale; // IE 9
      document.body.style.transform = scale; // General
    },
  },
  beforeDestroy() {
    this.$store.commit("destroyWanerMsg");
  },
};
</script>
